import { AgGridColumn, AgGridReact } from "ag-grid-react";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import {
  gridOptions,
  onFirstDataRendered,
  AG_GRID_LANGUAGE_ES,
  defaultColDef,
} from "../../../helpers/tablaConfig";
import { useState, useMemo } from "react";

export default function IncripcionesMateriasTable({ materias }) {
  const [gridApi, setGridApi] = useState(null);
  const [gridColumnApi, setGridColumnApi] = useState(null);

  const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);

  const onGridReady = (params) => {
    setGridApi(params.api);
    setGridColumnApi(params.columnApi);
  };

  const onPageSizeChanged = (newPageSize) => {
    var value = document.getElementById("page-size").value;
    gridApi.paginationSetPageSize(Number(value));
  };

  const columnDef = [
    {
      headerName: "Curso",
      field: "dmateria",
      cellStyle: { textAlign: "left", "white-space": "normal" },
      autoHeight: true,
    },
    {
      headerName: "Clase",
      field: "tipoclase",
      maxWidth: 120,
      cellStyle: { textAlign: "left", "white-space": "normal" },
      autoHeight: true,
    },
    {
      headerName: "Horario",
      field: "diaSemana",
      minWidth: 200,
      maxWidth: 200,
      cellStyle: { textAlign: "left", "white-space": "normal" },
      autoHeight: true,
    },
    {
      headerName: "Año",
      field: "anioCarrera",
      minWidth: 120,
      maxWidth: 120,
      resizable: true,
      cellStyle: { textAlign: "right" },
      type: "number",
      sortModel: "asc",
    },
    {
      headerName: "Profesores",
      field: "celda",
      minWidth: 300,
      cellStyle: { textAlign: "left", "white-space": "normal" },
      autoHeight: true,
      resizable: true,
    },
    {
      headerName: "Aula",
      field: "aula",
      minWidth: 300,
      cellStyle: { textAlign: "left", "white-space": "normal" },
      autoHeight: true,
      resizable: true,
    },
  ];

  return (
    <>
      <div
        id="notasGrid"
        className="ag-theme-alpine"
        style={{ height: "600px", width: "100%" }}
      >
        <div style={gridStyle} className="ag-theme-alpine">
          <AgGridReact
            rowData={materias}
            pagination={true}
            defaultColDef={defaultColDef}
            paginationPageSize={20}
            onGridReady={onGridReady}
            onFirstDataRendered={onFirstDataRendered}
            localeText={AG_GRID_LANGUAGE_ES}
            columnDefs={columnDef}
            resizable={true}
            animateRows={true}
          ></AgGridReact>
        </div>
      </div>
    </>
  );
}
